import { Theme } from '@mui/material';

export const HEADING_TOP = '-12px';
export const HEADING_PADDING_TOP = 3;
export const HEADING_PADDING_BOTTOM = 0.5;
export const HEADER_PADDING_Y = 1;
export const HEADER_LINE_HEIGHT = '1.5rem';

const headingHeight = (theme: Theme) =>
  `${theme.spacing(HEADING_PADDING_TOP + HEADING_PADDING_BOTTOM)} + ${theme.typography.h2.fontSize} * ${theme.typography.h2.lineHeight}`;

const headerHeight = (theme: Theme) =>
  `${theme.spacing(HEADER_PADDING_Y * 2)} + ${HEADER_LINE_HEIGHT}`;

export const headerStickyTop = (theme: Theme) =>
  `calc(${HEADING_TOP} + ${headingHeight(theme)})`;

export const projectRowStickyTop = (theme: Theme) =>
  `calc(${HEADING_TOP} + ${headingHeight(theme)} + ${headerHeight(theme)})`;
